import { useCallback, useEffect, useRef, useState } from "react";
import { deleteConsulting, getConsultingById, updateConsultationDone, updateConsultationMemberId } from "../../../api/consultings";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import MobileSubTitle from "../../../components/mobile/MobileSubTitle";
import { getMembers } from "../../../api/members";
import { formatDate } from "../../../util/Common";
import MobileConfirmDeleteModal from "../../../components/mobile/MobileConfirmDeleteModal";

const Container = styled.div`
  padding: 60px 16px;
`;

const ConsultingForm = styled.form`
  display: flex;
  flex-direction: column;
  font-size: 14px;
`;

const ConsultingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ConsultItemHalfLeft = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
`;

const ConsultItemHalfRight = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
`;

const ConsultItemLabel = styled.label`
  width: 100%;
  max-width: 80px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 5px;
  position: relative;

  span {
    position: absolute;
    right: calc(100% + 1px);
    top: -5px;
    width: 10px;
    height: 100%;
    color: #ff6666;
    display: block;
  }
`
const ConsultItemText = styled.p`
  text-align: left;
  width: 100%;
  padding: 10px 0;
`

const ConsultItemSelect = styled.select`
  width: 100%;
  height: 100%;
  border: 1px solid #9b9b9b;
  border-radius: 8px;
  padding: 6px 8px;
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: 14px;
  color: #333;
`
const FormItemTextarea = styled.textarea`
  width: 100%;
  height: 200px;
  border: 1px solid #9b9b9b;
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
  outline: none;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 40px;
`;

const Button = styled.button`
  width: 60px;
  height: 36px;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`;

const CancelButton = styled(Button)`
  background-color: #3d3d3d;
  &:hover {
    background-color: #2d2d2d;
  }
`;

const SaveButton = styled(Button)`
  background-color: #00a7db;
  &:hover {
    background-color: #0087b3;
  }
`;

const DeleteButton = styled(Button)`
  background-color: #ff6666;
  &:hover {
    background-color: #ff4444;
  }
`;

export function DetailConsulting() {
  const { id } = useParams();
  const [consulting, setConsulting] = useState({});
  const [done, setDone] = useState(false);
  const [memberId, setMemberId] = useState(null);
  const [members, setMembers] = useState([]);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

  const selectRef = useRef(null);

  useEffect(() => {
    if (selectRef.current && memberId) {
      selectRef.current.focus();
    }
  }, [selectRef, memberId]);

  const fetchConsulting = useCallback(async () => {
    const data = await getConsultingById(id);

    setConsulting(data.consultation);
    setMemberId(data.consultation.memberId || null);
    setDone(data.consultation.done);
  }, [id]);

  const navigate = useNavigate();

  const handleUpdateConsultingDone = async (e) => {
    try {
      e.preventDefault();
      if (!memberId) {
        alert("담당자를 선택해주세요.");
        return;
      }
      await updateConsultationDone(id, done);
      await updateConsultationMemberId(id, memberId);
      fetchConsulting();
      alert("상담문의를 저장하였습니다.")
      navigate("/admin/consulting");
    } catch (error) {
      console.error(error);
      alert("저장에 실패했습니다.");
    }
  };

  const handleDeleteConsulting = () => {
    setIsOpenDeleteModal(true);
  };

  const handleConfirmDelete = async (isConfirmed) => {
    setIsOpenDeleteModal(false);
    if (isConfirmed) {
      try {
        await deleteConsulting(id);
        alert("상담문의가 삭제되었습니다.");
        navigate("/admin/consulting");
      } catch (error) {
        console.error("상담문의 삭제 실패:", error);
        alert("삭제에 실패했습니다.");
      }
    }
  };

  useEffect(() => {
    fetchMembers();
  }, []);

  useEffect(() => {
    fetchConsulting();
  }, [fetchConsulting]);
  if (!consulting) return null;



  const fetchMembers = async () => {
    const data = await getMembers();
    setMembers(data.members);
  };


  return (
    <>
      <Container>
        <MobileSubTitle title="상담문의 - 상세보기" />
        <ConsultingForm onSubmit={handleUpdateConsultingDone}>
          <ConsultingContainer>
            <ConsultItemHalfLeft >
              <ConsultItemLabel>ID</ConsultItemLabel><ConsultItemText>{consulting.id}</ConsultItemText>
            </ConsultItemHalfLeft>
            <ConsultItemHalfRight>
              <ConsultItemLabel>등록일</ConsultItemLabel><ConsultItemText>{consulting.createdAt ? formatDate(consulting.createdAt) : "-"}</ConsultItemText>
            </ConsultItemHalfRight>
            <ConsultItemHalfLeft>
              <ConsultItemLabel>회사명</ConsultItemLabel> <ConsultItemText> {consulting.company}</ConsultItemText>
            </ConsultItemHalfLeft>
            <ConsultItemHalfRight>
              <ConsultItemLabel>이름</ConsultItemLabel><ConsultItemText>{consulting.author}</ConsultItemText>
            </ConsultItemHalfRight>
            <ConsultItemHalfLeft>
              <ConsultItemLabel>연락처</ConsultItemLabel>
              <ConsultItemText>{consulting.phone}</ConsultItemText>
            </ConsultItemHalfLeft>
            <ConsultItemHalfRight>
              <ConsultItemLabel>이메일</ConsultItemLabel>
              <ConsultItemText>{consulting.email ? consulting.email : "-"}</ConsultItemText>
            </ConsultItemHalfRight>
            <ConsultItemHalfLeft>
              <ConsultItemLabel><span>*</span>담당자</ConsultItemLabel>
              <ConsultItemSelect
                ref={selectRef}
                value={memberId || ""}
                onChange={({ target }) => setMemberId(target.value)}
                className={memberId ? "member-selected" : ""}
              >
                <option value="">담당자를 선택해주세요.</option>
                {members.map((member) => (
                  <option key={member.id} value={member.id}>{member.name} {member.role}</option>
                ))}
              </ConsultItemSelect>
            </ConsultItemHalfLeft>
            <ConsultItemHalfRight>
              <ConsultItemLabel>답변 방법</ConsultItemLabel>
              <ConsultItemText>{consulting.howToReply === "email" ? "이메일" : consulting.howToReply === "call" ? "전화" : consulting.howToReply === "message" ? "문자" : "기타 방법"}</ConsultItemText>
            </ConsultItemHalfRight>
            <ConsultItemHalfLeft>
              <ConsultItemLabel>서비스명</ConsultItemLabel><ConsultItemText>{consulting.title}</ConsultItemText>
            </ConsultItemHalfLeft>
            <ConsultItemHalfLeft>
              <ConsultItemLabel>문의내용</ConsultItemLabel><FormItemTextarea disabled value={consulting.content} />
            </ConsultItemHalfLeft>
            <ConsultItemHalfLeft>
              <ConsultItemLabel>
                <span>*</span>답변 여부
              </ConsultItemLabel>
              <ConsultItemSelect
                name="done"
                value={done}
                onChange={(e) => setDone(e.target.value)}
              ><span>*</span>답변 여부
                <option value="" key="default">답변 여부를 선택해주세요.</option>
                <option value={false}>진행중</option>
                <option value={true}>완료</option>
              </ConsultItemSelect>
            </ConsultItemHalfLeft>
          </ConsultingContainer>
          <ButtonContainer>
            <DeleteButton type="button" onClick={handleDeleteConsulting}>
              삭제
            </DeleteButton>
            <CancelButton type="button" onClick={() => navigate("/admin/consulting")}>
              취소
            </CancelButton>
            <SaveButton type="submit">저장</SaveButton>
          </ButtonContainer>
        </ConsultingForm>
      </Container>
      {isOpenDeleteModal && (
        <MobileConfirmDeleteModal onConfirm={handleConfirmDelete} />
      )}
    </>

  );
}
